/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Val1_DescInputs */

const en_dr_room_val1_desc = /** @type {(inputs: Dr_Room_Val1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A WhatsApp link is enough — a name, no sign-up. Only the room owner spends quota; everyone else writes cards and votes for free.`)
};

const id_dr_room_val1_desc = /** @type {(inputs: Dr_Room_Val1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cukup tautan WhatsApp — nama saja, tanpa daftar. Hanya pemilik ruang yang memakai kuota; peserta lain menulis kartu dan vote tanpa biaya.`)
};

/**
* | output |
* | --- |
* | "A WhatsApp link is enough — a name, no sign-up. Only the room owner spends quota; everyone else writes cards and votes for free." |
*
* @param {Dr_Room_Val1_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_val1_desc = /** @type {((inputs?: Dr_Room_Val1_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Val1_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_val1_desc(inputs)
	return en_dr_room_val1_desc(inputs)
});